import { useEffect } from 'react';
import { useIsDespia } from './use-native-platform';

/**
 * Blocks the native edge-swipe-back gesture in the Despia WebView.
 * Intercepts touchstart events on the left edge (<30px) and prevents
 * the WebView from triggering the native back navigation.
 */
export function useDisableSwipeBack() {
  const isDespia = useIsDespia();

  useEffect(() => {
    if (!isDespia) return;

    const handler = (e: TouchEvent) => {
      if (e.touches[0].clientX < 30) {
        e.preventDefault();
      }
    };

    document.addEventListener('touchstart', handler, { passive: false });
    return () => document.removeEventListener('touchstart', handler);
  }, [isDespia]);
}
